// Module
var code = `<h2><span>SECTION:</span> {{title}}</h2>
`;
// Exports
module.exports = code;